import React, {FormEvent, MouseEvent, useMemo, useState} from 'react';

import {useTranslation} from 'react-i18next';

import {ReactComponent as ArrowIcon} from 'assets/svg/arrow-bottom.svg';
import {Button, ButtonVariant} from 'components/ui-kit/Button';
import {InnerFilters, InnerFiltersElement} from 'types';

import {FlatGridFieldConfig} from '../types';

import {ButtonsContainer, CustomButton, CustomIcon, FieldWrapper} from './styled';

interface Props {
    columns: FlatGridFieldConfig[];
    filters?: InnerFilters;
    onChange: (value: InnerFiltersElement) => void;
    onSubmit: () => void;
    onReset: () => void;
    className?: string;
}

export const Filters = ({columns, filters, onChange, onSubmit, onReset, className}: Props) => {
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        onSubmit();
    };

    const handleReset = (e: MouseEvent) => {
        e.preventDefault();
        onReset();
    };

    const handleChange = (id: string, data: any) => {
        // TODO input field has bad structure of onChange parameter
        if (data && data.target != null) {
            onChange({id, value: data.target.value});
        } else {
            onChange({id, value: data});
        }
    };

    const filterColumns = useMemo(() => columns.filter((elem) => elem.filter != null), columns);

    return (
        <div className={className}>
            <CustomButton onClick={() => setIsOpen(!isOpen)}>
                {t('components.endlessList.filtration')}
                <CustomIcon width={10} height={6} source={ArrowIcon} active={isOpen} />
            </CustomButton>
            {isOpen && (
                <form onSubmit={handleSubmit}>
                    {filterColumns.map((elem, index) => (
                        <FieldWrapper key={index}>
                            {React.cloneElement(elem.filter!, {
                                ...elem.filter!.props,
                                label: elem.header,
                                value: (filters && filters[elem.id]) || null,
                                onChange: (value: any) => handleChange(elem.id, value),
                            })}
                        </FieldWrapper>
                    ))}

                    <ButtonsContainer>
                        <Button variant={ButtonVariant.Normal} type="submit">
                            {t('components.endlessList.Submit')}
                        </Button>
                        <Button variant={ButtonVariant.Text} type="reset" onClick={handleReset}>
                            {t('components.endlessList.Reset')}
                        </Button>
                    </ButtonsContainer>
                </form>
            )}
        </div>
    );
};
